/**
 * Custom SafeAreaView Component
 *
 * Wraps react-native-safe-area-context's SafeAreaView with gluestack-ui styling support.
 * This replaces the deprecated React Native SafeAreaView while maintaining all
 * gluestack-ui props ($xl-width, bg, flex, etc.) and responsive breakpoints.
 *
 * Usage:
 *   import { SafeAreaView } from 'common/components/SafeAreaView';
 *
 *   <SafeAreaView
 *     $xl-width={1280}
 *     bg="$backgroundLight0"
 *     flex={1}
 *   >
 *     {children}
 *   </SafeAreaView>
 */

import { SafeAreaView as RNSafeAreaView } from 'react-native-safe-area-context';
import { styled } from '@gluestack-ui/themed';

export const SafeAreaView = styled(
  RNSafeAreaView,
  {},
  {
    componentName: 'SafeAreaView',
    ancestorStyle: ['_text'],
  },
);
